/**
 * Checks if a filter value is valid (not empty)
 * @param {*} value - Filter value to check
 * @returns {boolean} - True if value is valid
 */
export const hasValidValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return Boolean(value);
};

/**
 * Generates a unique filter ID using crypto.randomUUID
 * @returns {string} - Unique identifier
 */
export const generateFilterId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

/**
 * Creates an empty filter object
 * @returns {Object} - Empty filter with unique ID
 */
export const createEmptyFilter = () => ({
  id: generateFilterId(),
  type: '',
  value: [],
});

